<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
    // import MobHeader from './components/mob-header.vue'
    export default {
        name: 'App',
        data() {
            return {};
        },
        components: {
            // MobHeader
            // HelloWorld,
            // header:header
        },
        created() {
            // eden
            /*
            this.$axios({
                url: 'http://www.ljxzxyy.cn/api/index/index',
                method: 'post',
                params: {},
            })
                .then((response) => {
                    //请求成功
                    console.log('index', response.data);
                })
                .catch((error) => {
                    //请求失败
                    console.log('index', error);
                });
            */
        },
        mounted() {},
        methods: {},
    };
</script>

<style></style>
